var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-suggestion-confirmation"},[_c('confirmation-content',[_c('div',{staticClass:"confirmation-content__title"},[_vm._v("Dziękujemy!")]),_c('div',{staticClass:"confirmation-content__subtitle"},[_vm._v(" Wkrótce otrzymasz od nas aktualną propozycję wyjazdu. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }